import { useAuthStore } from 'src/store/auth';
import { RoleType } from 'src/constants';
import { useState } from 'react';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  isOpen?: boolean;
}

const Sidebar = ({ activeTab, setActiveTab }: SidebarProps) => {
  const { user, logout } = useAuthStore();
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const menuItems = [
    {
      id: 'underwriting',
      label: 'Underwriting',
      icon: '/icons/validation-approval.svg',
      iconActive: '/icons/validation-approval-black.svg',
    },
    // {
    //   id: 'id-cards',
    //   label: 'ID Cards',
    //   icon: '/icons/identification.svg',
    //   iconActive: '/icons/identification-black.svg',
    // },
    {
      id: 'members',
      label: 'Members',
      icon: '/icons/user-list.svg',
      iconActive: '/icons/user-list-black.svg',
    },
    // {
    //   id: 'groups',
    //   label: 'Groups',
    //   icon: '/icons/user-group.svg',
    //   iconActive: '/icons/user-group-black.svg',
    // },
  ];

  // TODO admins/managers ещё этот пункт но его я не видел в фигме
  const menuAdminItems = [
    {
      id: 'admin-groups',
      label: 'Groups',
      icon: '/icons/user-group.svg',
      iconActive: '/icons/user-group-black.svg',
    },
    {
      id: 'admins',
      label: 'Admins/Managers',
      icon: '/icons/user-list.svg',
      iconActive: '/icons/user-list-black.svg',
    },
  ];

  return (
    <div className="w-64 bg-secondary flex flex-col rounded-[32px] h-[calc(100%-32px)] my-4 ml-4">
      <div className="p-6">
        <img src="/icons/onehealth-logo.svg" alt="logo" />
      </div>

      <nav className="flex-1 px-4">
        <ul className="space-y-2">
          {menuItems.map(item => (
            <li key={item.id}>
              <button
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center px-4 py-3 rounded-full transition-colors ${
                  activeTab === item.id
                    ? 'bg-white text-black'
                    : 'text-white hover:bg-white/10'
                }`}
              >
                <img
                  src={activeTab === item.id ? item.iconActive : item.icon}
                  alt={item.label}
                  className="mr-3 w-5 h-5"
                />
                {item.label}
              </button>
            </li>
          ))}
        </ul>
        {user?.role === RoleType.Admin && (
          <>
            <p className="m-4 font-semibold text-white/80">Admin</p>
            <ul className="space-y-2">
              {menuAdminItems.map(item => (
                <li key={item.id}>
                  <button
                    onClick={() => setActiveTab(item.id)}
                    className={`w-full flex items-center px-4 py-3 rounded-full transition-colors ${
                      activeTab === item.id
                        ? 'bg-white text-black'
                        : 'text-white hover:bg-white/10'
                    }`}
                  >
                    <img
                      src={activeTab === item.id ? item.iconActive : item.icon}
                      alt={item.label}
                      className="mr-3 w-5 h-5"
                    />
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}
      </nav>

      <div className="p-4 border-t border-white/20">
        <div className="relative">
          <button
            type="button"
            className="flex w-full items-center justify-between gap-3"
            onClick={() => setIsProfileMenuOpen(v => !v)}
          >
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <span className="text-white text-sm font-medium">
                  {(user?.firstName?.[0] || 'J').toUpperCase()}
                  {(user?.lastName?.[0] || 'D').toUpperCase()}
                </span>
              </div>
              <div className="text-left">
                <p className="text-white font-medium">
                  {user ? `${user.firstName} ${user.lastName}` : 'John Doe'}
                </p>
                <p className="text-white/70 text-sm">
                  {user?.email || 'johndoe@gmail.com'}
                </p>
              </div>
            </div>
            <svg
              className={`w-4 h-4 text-white transition-transform ${
                isProfileMenuOpen ? 'rotate-180' : ''
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {isProfileMenuOpen && (
            <div className="absolute right-0 bottom-full mb-2 bg-white text-black rounded-md shadow-lg min-w-[140px] z-50">
              <button
                className="w-full text-left px-4 py-2 hover:bg-black/5 rounded-md"
                onClick={() => {
                  setIsProfileMenuOpen(false);
                  logout();
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
